/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RootDomainList
 */
export interface RootDomainList {
}

/**
 * Check if a given object implements the RootDomainList interface.
 */
export function instanceOfRootDomainList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RootDomainListFromJSON(json: any): RootDomainList {
    return RootDomainListFromJSONTyped(json, false);
}

export function RootDomainListFromJSONTyped(json: any, ignoreDiscriminator: boolean): RootDomainList {
    return json;
}

export function RootDomainListToJSON(value?: RootDomainList | null): any {
    return value;
}

